import axios from 'axios';
// config
import { HOST_API, LOCAL_API_URLS, USE_LOCAL_APIS } from '../config';

// ----------------------------------------------------------------------

const LOCAL_ROUTE_URLS: Record<string, string> = {
  '/auth': LOCAL_API_URLS.auth,
  '/user': LOCAL_API_URLS.auth,
  '/api/account': LOCAL_API_URLS.auth,
  '/wallet': LOCAL_API_URLS.wallet,
  '/points': LOCAL_API_URLS.pointsEngine,
  '/points-engine': LOCAL_API_URLS.pointsEngine,
  '/benefits': LOCAL_API_URLS.benefits,
  '/invoices': LOCAL_API_URLS.invoices,
  '/tiers': LOCAL_API_URLS.tiers,
  '/missions': LOCAL_API_URLS.missions,
  '/analytics': LOCAL_API_URLS.analytics,
  '/achievements': LOCAL_API_URLS.achievements,
  '/partners': LOCAL_API_URLS.partners,
};

export const createApiClient = () => {
  const axiosInstance = axios.create({ baseURL: HOST_API });

  axiosInstance.interceptors.request.use((config) => {
    const requestUrl = config.url;

    if (USE_LOCAL_APIS && requestUrl) {
      const route = Object.keys(LOCAL_ROUTE_URLS).find(
        (prefix) => requestUrl === prefix || requestUrl.startsWith(`${prefix}/`)
      );

      if (route) {
        config.baseURL = LOCAL_ROUTE_URLS[route];
      }
    }

    return config;
  });

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject((error) || 'Something went wrong')
  );

  return axiosInstance;
};

const axiosInstance = createApiClient();

export default axiosInstance;
